<template>
    
<v-flex xs12 class="pa-0">
    <v-text-field 
        prepend-icon='mdi-calendar'
        @click:prepend='dialog = true' 
        mask='##-##-####' 
        return-masked-value 
        v-on:focus='setFocus' 
        v-model='date' 
        v-on:blur='handleBlur'
        :label='label'
        :disabled='disabled'
        :rules='dateRules'
        @input="change()"
        >
        </v-text-field>
    <v-dialog
        v-model="dialog"
        width="290px"
        >

        <v-date-picker min="1899/31/12" :color="app.color" @change="change()" v-model="picker" scrollable locale="nl-NL">
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="dialog = false">OK</v-btn>
            <v-spacer></v-spacer>
        </v-date-picker>
    </v-dialog>   
</v-flex>

</template>

<script>
import moment from "moment";
import { mapState } from "vuex";

export default {
  props: {
    value: {
      type: String
    },
    label: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: false,
      editing: false,
      rawinput: null,
      dateRules: [
        // v => !!v || "Datum is verplicht",
        v => moment(v, "DD-MM-YYYY").isValid() || "Datum is niet geldig",
        v =>
          moment(v, "DD-MM-YYYY").isAfter(moment("1900-01-01", "YYYY-MM-DD")) ||
          "Datum ligt te ver in het verleden"
      ]
    };
  },
  methods: {
    checkAndEmit(e) {
      if (moment(e, "DD-MM-YYYY").isValid()) {
        if (moment(e, "DD-MM-YYYY").isAfter(moment("01-01-1900"))) {
          this.$emit("input", e);
          this.rawinput = null;
        }
      }
    },
    handleBlur() {
      if (this.rawinput != null) {
        this.checkAndEmit(
          moment(this.rawinput, "DD-MM-YYYY", "DD-MM-YY").format("DD-MM-YYYY")
        );
      }
      this.editing = false;
    },
    change() {
      this.$store.state.app.contract.hasChange = true;
    },
    setFocus() {
      this.editing = true;
    }
  },
  computed: {
    ...mapState(["app"]),
    date: {
      get() {
        if (this.value != "" && this.value !== undefined) {
          return this.value;
        } else {
          return null;
        }
      },
      set(e) {
        if (this.editing) {
          this.rawinput = e;
        }
      }
    },
    picker: {
      get() {
        if (this.rawinput !== null) {
          return moment(this.rawinput, "DD-MM-YYYY").format("YYYY-MM-DD");
        } else {
          if (this.value != "" && this.value !== undefined) {
            return moment(this.value, "DD-MM-YYYY").format("YYYY-MM-DD");
          } else {
            return null;
          }
        }
      },
      set(e) {
        this.checkAndEmit(moment(e, "YYYY-MM-DD").format("DD-MM-YYYY"));
      }
    }
  },
  mounted() {
    this.rawinput = null;
    this.editing = false;
  }
};
</script>
